import { ACCOUNT_PARAM } from '#pplx/frontend/account-navigation/constants.js';
import { updateSearchParams } from '#pplx/frontend/apps/ask/routing/historySearchParams.js';
import { setActiveAccountId } from '#pplx/frontend/browser-storage/activeAccount.js';
import { validateUuid } from '#pplx/frontend/common/validateUuid.js';
function stripAccountParamFromUrl() {
    const params = new URLSearchParams(window.location.search);
    if (params.has(ACCOUNT_PARAM)) {
        updateSearchParams({ [ACCOUNT_PARAM]: undefined });
    }
}
/**
 * Applies the ephemeral `?pplx_account={userId}` bootstrap param: sets it as this tab's
 * active account, then strips it from the URL so it never lands in history, a shared link,
 * or a reload. This is how the account switcher (and notification deep-links) bind a freshly
 * opened tab to a specific account.
 *
 * No-op when the param is absent or not a valid userId — i.e. every load until the switcher
 * (Phase 3+) starts producing these URLs, so this is dormant on its own. Must run before the
 * first authenticated request so header injection (`X-Pplx-Account`) sees the right account.
 */
export function applyAccountFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const account = params.get(ACCOUNT_PARAM);
    if (!account || !validateUuid(account)) {
        return;
    }
    setActiveAccountId(account);
    // Strip the param via the sanctioned history helper (preserves other params + the hash)
    // so the userId doesn't persist into history, a reload, or a shared/copied link.
    stripAccountParamFromUrl();
}
//# sourceMappingURL=accountSwitchHandler.js.map